export let searchTextAutoCompleteDescription = "PrliQd";
export let searchTextAutoCompleteTabHint = "$VZEad";
export default {searchTextAutoCompleteDescription,searchTextAutoCompleteTabHint};